import { render, staticRenderFns } from "./ClientEditContactsDialog.vue?vue&type=template&id=293e9140"
import script from "./ClientEditContactsDialog.vue?vue&type=script&lang=js"
export * from "./ClientEditContactsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports